<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('personal.selectShippingAddress')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="search-wrap">
      <div class="location text-blue" @click="geolocation()">
        <van-icon name="location-o" />
        <span>{{
          loadFlag ? $t("life.locating") : location && location.city
        }}</span>
        <!-- <van-icon v-if="type" name="arrow-down" /> -->
      </div>
      <van-search
        v-model="searchVal"
        shape="round"
        :placeholder="$t('personal.enterShippingAddress')"
        @input="getGoogleAddress2"
      />
    </div>
    <div class="scroll-wrapper">
      <div class="map-box">
        <div class="my-posi" @click="backMyPosi">
          <i class="icon-location"></i>
        </div>
        <gmap-map
          :options="{
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false
          }"
          :center="centers"
          :zoom="15"
          class="maps"
          map-type-id="terrain"
          style="width: 100%; height: 300px"
          @idle="handler"
          ref="map"
        >
          <gmap-marker
            @dragend="updateMaker"
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="m.icon"
            :clickable="true"
            :draggable="true"
            @click="centers = m.position"
          />
        </gmap-map>
      </div>
      <div class="address">
        <div
          class="item"
          v-for="(item, index) in addressList"
          :key="index"
          @click="addressGetLatlng(item)"
        >
          <div class="info">
            <h3>{{ item.name }}</h3>
             <p>{{ item.vicinity }}</p>
          </div>
          <i class="icon-location" v-if="curAddress == item.name"></i>
        </div>
      </div>
    </div>
    <loading v-if="loadFlag" />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import Loading from "@/components/common/loading";
export default {
  props: ["data"],
  name: "deliveryAddress1",
  meta: {
    power: false
  },
  components: {
    Loading
  },
  data() {
    return {
      loadFlag: false,
      searchVal: "",
      curAddress: "",
      addressList: [],
      centers: {
        lat: 0,
        lng: 0
      },
      markers: [],
      moveLatLng: ""
    };
  },
  created() {
    if (this.data && this.data.address) {
      this.setPosition();
    } else {
      this.geolocation();
    }
  },
  mounted() {
    this.$refs.map.$on("center_changed", maps => {
      this.moveLatLng = maps.lat() + "," + maps.lng();
      // require('@/assets/images/public/logo_icon@2x.png')
    });
  },
  computed: {
    ...mapGetters(["location", "language"])
  },
  methods: {
    backMyPosi() {
      //回到我的位置
      let position = {};
      position.lat = this.centers.lat;
      position.lng = this.centers.lng;
      this.$refs.map.panTo(position);
    },
    handler() {
      if (this.moveLatLng == "") {
        return;
      }
      let position = {};
      position.lat = Number(this.moveLatLng.split(",")[0]);
      position.lng = Number(this.moveLatLng.split(",")[1]);
      this.$set(this.markers, [1], { position });
      this.latlngGetAddress(this.moveLatLng);
    },
    navBarBack() {
      // 返回事件
      this.$emit("update:mapsFlag", false);
    },
    setPosition() {
      // 设置位置
      if (!_.isEmpty(this.data)) {
        this.centers.lat = this.data.latitude;
        this.centers.lng = this.data.longitude;
      }
      this.markers = [];
      //我的位置
      let myPosi = {};
      myPosi.lat = this.centers.lat;
      myPosi.lng = this.centers.lng;
      this.markers.push({
        position: myPosi,
        icon: require("@/assets/images/public/logo_icon@2x.png")
      });
      //中心点
      let position = {};
      position.lat = this.centers.lat;
      position.lng = this.centers.lng;
      this.markers.push({
        position
      });
    },
    setPosition2(centers) {

      this.markers = [];
      //我的位置
      let myPosi = {};
      myPosi.lat = centers.lat;
      myPosi.lng = centers.lng;
      this.markers.push({
        position: myPosi,
        icon: require("@/assets/images/public/logo_icon@2x.png")
      });
      //中心点
      let position = {};
      position.lat =centers.lat;
      position.lng =centers.lng;
      this.markers.push({
        position
      });
    },
    geolocation() {
      // 定位
      let vm = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            // 获取地理位置成功
            console.log("经度:" + position.coords.longitude);
            console.log("纬度:" + position.coords.latitude);
            console.log("准确度:" + position.coords.accuracy);
            console.log("海拔:" + position.coords.altitude);
            console.log("海拔准确度:" + position.coords.altitudeAcuracy);
            console.log("行进方向:" + position.coords.heading);
            console.log("地面速度:" + position.coords.speed);
            console.log("请求的时间:" + new Date(position.timestamp));
            let params = {};
            params.language = vm.language == "en" ? "en_US" : "zh_CN";
            params.latlng =
              position.coords.latitude + "," + position.coords.longitude;
            params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
            console.log("getLocation.params", params);
            vm.loadFlag = true;
            vm.$get("https://maps.googleapis.com/maps/api/geocode/json", params)
              .then(res => {
                vm.loadFlag = false;
                console.log("getLocation.res", res);
                if (res.status == "OK") {
                  vm.$store.dispatch("SET_LOCATION", res.results);
                  vm.centers = res.results[0].geometry.location;
                  vm.setPosition2(res.results[0].geometry.location);
                  vm.curAddress = res.results[0].formatted_address;
                  vm.getGoogleAddress(res.results[0].geometry.location.lat+','+res.results[0].geometry.location.lng);
                } else {
                  vm.$toast("定位失败");
                }
              })
              .catch(error => {
                vm.loadFlag = false;
                console.log("catch.error", error);
              });
          },
          function(error) {
            // 获取地理位置失败
            console.log("function.error", error);
            vm.loadFlag = false;
            switch (error.code) {
              case error.PERMISSION_DENIED:
                vm.$toast("定位失败,用户拒绝请求地理定位");
                break;
              case error.POSITION_UNAVAILABLE:
                vm.$toast("定位失败,位置信息是不可用");
                break;
              case error.TIMEOUT:
                vm.$toast("定位失败,请求获取用户位置超时");
                break;
              case error.UNKNOWN_ERROR:
                vm.$toast("定位失败,定位系统失效");
                break;
            }
          },
          {
            // 指示浏览器获取高精度的位置，默认为false
            enableHighAccuracy: true,
            // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
            timeout: 5000,
            // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
            maximumAge: 3000
          }
        );
      } else {
        vm.$toast("Your browser does not support Geolocation!");
      }
    },
    addressGetLatlng(data) {
      // 根据地址获取坐标
      console.log("addressGetLatlng.data", data);
      let vm = this;
      vm.curAddress = data.name;
      let params = {};
      params.place_id = data.place_id;
      params.language = vm.language == "en" ? "en_US" : "zh_CN";
      params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
      vm.$get("https://maps.googleapis.com/maps/api/geocode/json", params).then(
        res => {
          console.log("addressGetLatlng", res);
          if (res.status == "OK") {
            this.$store.dispatch("SET_LOCATION", res.results);
            vm.centers = res.results[0].geometry.location;
            console.log("centers", vm.centers);
            vm.markers = [];
            let position = {};
            position.lat = vm.centers.lat;
            position.lng = vm.centers.lng;
            this.markers.push({ position });
            console.log("markers", vm.markers);
            let obj = {};
            obj.latitude = vm.centers.lat;
            obj.longitude = vm.centers.lng;
            obj.place_id = res.results[0].place_id;
            obj.address = data.name+","+data.vicinity;
            console.log("getAddress", obj);
            vm.$emit("getAddress", obj);
            vm.$emit("update:mapsFlag", false);
          }
        }
      );
    },
    latlngGetAddress(latlng) {
      // 根据坐标获取地址
      let vm = this;
      let params = {};
      params.latlng = latlng;
      params.language = vm.language == "en" ? "en_US" : "zh_CN";
      params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
      vm.$get("https://maps.googleapis.com/maps/api/geocode/json", params).then(
        res => {
          console.log("latlngGetAddress", res);
          if (res.status == "OK") {
            this.$store.dispatch("SET_LOCATION", res.results);
            vm.curAddress = res.results[0].formatted_address;
            vm.getGoogleAddress(latlng);
            console.log("curAddress", vm.curAddress);
          }
        }
      );
    },
    getGoogleAddress(value) {
      // 搜索谷歌地图
      let vm = this;
      let params = {};
      params.location = value;
      vm.addressList = [];
      vm.$post("/app/help/getGoogleAddress", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("getGoogleAddress", res);
        vm.addressList = res.data;
      });
    },

    getGoogleAddress2(value) {
      // 搜索谷歌地图
      let vm = this;
      let params = {};
      params.title = value;
      vm.addressList = [];
      vm.$post("/app/help/getGoogleAddress", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("getGoogleAddress", res);
        vm.addressList = res.data;
      });
    },
    updateMaker: function(event) {
      // 获取新坐标信息
      this.centers.lat = event.latLng.lat();
      this.centers.lng = event.latLng.lng();
      console.log("updateMaker.centers", this.centers);
      let position = {};
      position.lat = Number(this.moveLatLng.split(",")[0]);
      position.lng = Number(this.moveLatLng.split(",")[1]);
      this.$set(this.markers, [1], { position });
      console.log("updateMaker.markers", this.markers);
      let latlng = event.latLng.lat() + "," + event.latLng.lng();
      this.latlngGetAddress(latlng);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.search-wrap {
  top: 44px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  height: 48px;
  background: #fff;
  .location {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 90px;
    font-size: 14px;
    overflow: hidden;
    .goodsStore {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .van-icon {
      margin-right: 2px;
      font-size: 16px;
    }
  }
  .van-search {
    flex: 1;
    margin-left: 5px;
    padding: 0;
    &.white {
      .van-search__content {
        background: #fff;
        border: 1.1px solid #dcdcdc;
      }
    }
    .van-cell {
      padding: 3px 8px 3px 0;
    }
    .van-search__content {
      background: #f0f0f0;
    }
    /deep/.van-icon-search {
      color: #bcbcbc;
    }
  }
}

.fixed-search {
  top: 44px;
  position: relative;
}
.scroll-wrapper {
  top: 92px;
}
.map-box {
  height: 300px;
  position: relative;
}
.my-posi {
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  .icon-location {
    display: block;
    width: 30px;
    height: 30px;
    background: url("@{images}public/location@2x.png");
    background-size: 100%;
  }
}
.maps {
  background: #f4f4f4;
  z-index: 999;
}

.address {
  padding: 5px 15px;
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    line-height: 1.2;
    border-bottom: 1.1px solid #e9e9e9;
    .info {
      flex: 1;
      overflow: hidden;
      h3 {
        font-size: 14px;
      }
      p {
        margin-top: 5px;
        color: #666;
      }
    }
    .icon-location {
      width: 16px;
      height: 16px;
      background: url("@{images}public/location@2x.png");
      background-size: 100%;
    }
  }
}
</style>
